import axios from 'axios'
import store from '@/store'
import {
  getToken,
  getBaseURL
} from '@/utils/auth'
import Vue from 'vue';
// import storage from 'good-storage'

// create an axios instance
let errorTitle = ''; //错误提示
const service = axios.create({
  baseURL: getBaseURL(), // 服务器
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 600000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token')
    if (token && token.length > 0) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      config.headers['X-CSRF-Token'] = token
    }
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    const res = response.data

    if (res.code != 200) {
      let vm = new Vue();
      if (res.code == 100022) {
        localStorage.removeItem('token')
      }
      if (errorTitle == res.msg) {
       if (res.code === 100020 || res.code === 100026 || res.code === 100027 || res.code === 100025 || res.code ===
         100022 || res.code === 100021) {
             return res.code
    //    console.log(vm)
       }else{
            return res.code
       }

     
      } else {
        errorTitle = res.msg
      }
      vm.$bvToast.toast(res.msg, {
        title: res.code,
        variant: 'danger',
        toaster: 'b-toaster-top-center',
        solid: true
      })

    } else {

      return res
    }


  },
  error => {
    let vm = new Vue()
    vm.$bvToast.toast(error.msg, {
      title: error.code,
      variant: 'danger',
      toaster: 'b-toaster-top-center',
      solid: true
    })
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js